/* eslint-disable react/prop-types */
// LIBRARY
import React from 'react';
import moment from 'moment';
import { Row, Form, Button, Col, Select, DatePicker, message } from 'antd';
import PropTypes from 'prop-types';
import PageTitle from 'shared_components/page_title';
import { RegexInput, AlphaNumInput, NumberInput } from 'shared_components/pattern_input';
import { fetchLabResult } from 'services/lab_result/result';
import { updateSession } from 'services/session/session';
import FIELD_RULES from './constant';

import './searchform.css';
import { fieldLabels } from 'shared_components/search_patient_form/settings';

const { Option } = Select;
const { RangePicker } = DatePicker;

class SearchForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
		};

		this.formRef = React.createRef();
	}

	search = () => {
		const { updateLabResults } = this.props;
		const fieldsValue = this.formRef.current.getFieldsValue();
		const { dateSpan, ...restProps } = fieldsValue;
		const fromDate = dateSpan ? dateSpan[0].format('YYYYMMDD') : null;
		const toDate = dateSpan ? dateSpan[1].format('YYYYMMDD') : null;

		// Reset session when user searches
		updateSession([]);

		this.setState({ isLoading: true }, async () => {
			const labResults = await fetchLabResult({
				...restProps,
				dateCategory: null,
				fromDate,
				toDate,
			});

			if (labResults) {
				if (labResults.length <= 0) message.info('No results found.');

				updateLabResults(labResults);
			}

			this.setState({ isLoading: false });
		});
	};

	onClickClear = () => {
		const { updateLabResults } = this.props;
		const { resetFields } = this.formRef.current;

		resetFields();
		updateLabResults([]);
	};

	disabledDate = current => {
		// Prevent select days after today and today
		return current && current > moment().endOf('day');
	};

	handleFocusID = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ patientName: '' });
	};

	handleFocusName = () => {
		const { setFieldsValue } = this.formRef.current;

		//setFieldsValue({ patientID: '', requestDate: moment() });
		//remove resetting date on focus name field
		setFieldsValue({ patientID: '' });
	};


	render() {
		const { pageTitle } = this.props;
		// const { getFieldDecorator } = this.props.form;
		const { isLoading } = this.state;

		return (
			<Form
				ref={this.formRef}
				onFinish={this.search}
				initialValues={{
					dateSpan: [moment(new Date()), moment(new Date())],
					status: 'All',
				}}
				id="searchlabtestresultform"
				className="labresult-search-form"
				layout="vertical"
			>
				<PageTitle pageTitle={pageTitle} />
				<div className="space-y-md"></div>
				<div className="container">
					<Col className="patient-id">
						<Form.Item name="patientID" label={fieldLabels.patientID} rules={FIELD_RULES.patientId}>
							<AlphaNumInput maxLength={15} onFocus={this.handleFocusID}/>
						</Form.Item>
					</Col>
					<Col className="name">
						<Form.Item name="patientName" label="PATIENT NAME" rules={FIELD_RULES.patientName}>
							<RegexInput
								regex={/[A-Za-z0-9, -]/}
								allowClear
								maxLength={100}
								placeholder="Lastname,Firstname"
								onFocus={this.handleFocusName}
							/>
						</Form.Item>
					</Col>
					<Col className="specimen-id">
						<Form.Item
							name="sampleSpecimenID"
							label="SAMPLE ID"
							rules={FIELD_RULES.sampleSpecimenID}
						>
							<AlphaNumInput allowClear maxLength={15} />
						</Form.Item>
					</Col>

					<Col className="date">
						<Form.Item
							name="dateSpan"
							label="REQUEST DATE FROM - REQUEST DATE TO"
							rules={FIELD_RULES.dateSpan}
						>
							<RangePicker
								format={'MM-DD-YYYY'}
								allowClear
								disabledDate={this.disabledDate}
								style={{ width: '100%' }}
							/>
						</Form.Item>
					</Col>
					<Col className="status">
						<Form.Item name="status" label="STATUS" rules={FIELD_RULES.status}>
							<Select placeholder="Please select a status" style={{ width: '100%' }} allowClear>
								{/* <Option value="All">ALL</Option>
								<Option value="Checked In">CHECKED IN</Option>
								<Option value="Instrument Result">INSTRUMENT RESULT</Option>
								<Option value="Preliminary">PRELIMINARY</Option>
								<Option value="Released">RELEASED</Option> */}
								<Option value="All">ALL</Option>
								<Option value="1">CHECKED-IN</Option>
								<Option value="2">SAVED</Option>
								<Option value="3">APPROVED</Option>
								<Option value="4">UNAPPROVED</Option>
								<Option value="5">ANALYZER PROCESSED</Option>
								<Option value="6">ANALYZER RESULT</Option>
								{/* <Option value="7">LOCATION CHECKED-IN SPECIMEN</Option> */}
								<Option value="8">PRINT RESULT REPORT</Option>
							</Select>
						</Form.Item>
					</Col>
					<Col className="button-container">
						<Form.Item style={{ marginTop: 31 }}>
							<div className="button">
								<Button shape="round" onClick={this.onClickClear} style={{ width: 120 }}>
									CLEAR
								</Button>
								<Button
									type="primary"
									shape="round"
									htmlType="submit"
									loading={isLoading}
									style={{ width: 120 }}
									// disabled={isDisableSubmit}
								>
									SEARCH
								</Button>
							</div>
						</Form.Item>
					</Col>
				</div>
				<div className="space-y-md"></div>
			</Form>
		);
	}
}

SearchForm.propTypes = {
	pageTitle: PropTypes.string.isRequired,
	updateLabResults: PropTypes.func.isRequired,
};

// export default Form.create({ name: 'searchlabtestform' })(SearchForm);
export default SearchForm;
